import { render, staticRenderFns } from "./LiveSearch.vue?vue&type=template&id=0a965374"
import script from "./LiveSearch.vue?vue&type=script&lang=js"
export * from "./LiveSearch.vue?vue&type=script&lang=js"
import style0 from "./LiveSearch.vue?vue&type=style&index=0&id=0a965374&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports